<div class="navbar navbar-sm navbar-footer border-top">
	<div class="container-fluid">
		<span>&copy; {{year}} MANGO</span>
	</div>
</div>